export default "__VITE_ASSET__BFpYl8Ed__"